

import { defineComponent } from 'vue';
import { store } from '@/store';
import { M_MENU } from '@/store/mutations-types';
import { formatKm } from '@/utils/formatkm';
import api from '@/api/api';

export default defineComponent({
    name: "HomeView",
    data() {
        return {
            dsCompromissos: [],
            dsPendencias: [],
            dsTime: [],
            dsCarros: [],
            totalizadorTempos: 0,
            minCol: 4
        }
    },

    computed: {
        isAdmin() {
            return this.$store.state.infoUser.current?.departamento === 4;
        },
        totalComPendencia() {
            return this.dsCarros.length;
        }
    },

    methods: {
        updateMinCol: function () {
            const totalCards = 2 + (this.dsTime.length ? 1 : 0) + (this.dsCarros.length ? 1 : 0);

            this.minCol = 12 / totalCards;
        },
        temPendencia: function (car) {
            return Boolean(car.kmPendente)
                || car.itensPendentesManutencao.length > 0
                || car.solicitacoesEmAberto > 0
                || car.solicitacoesAguardando > 0;
        },
        loadCarros: async function () {
            if (!this.isAdmin) return;

            try {
                const { data } = await api.get('/cars-maintenance/cars');

                const urgencia = (car) => car.itensPendentesManutencao.some(i => i.vencida) ? 0 : 1;

                this.dsCarros = data
                    .filter(car => this.temPendencia(car))
                    .sort((a, b) => urgencia(a) - urgencia(b) || String(a.numero).localeCompare(String(b.numero), 'pt-BR', { numeric: true }));
            } catch (error) {
                console.log(error)
            } finally {
                this.updateMinCol();
            }
        },
        textoPendencias: function (car) {
            return [
                car.kmPendente ? 'Km sem lançar' : null,
                car.solicitacoesEmAberto ? `Solicitação em aberto (${car.solicitacoesEmAberto})` : null,
                car.solicitacoesAguardando ? `Solicitação aguardando manutenção (${car.solicitacoesAguardando})` : null
            ].filter(Boolean).join(' · ');
        },
        textoManutencoes: function (car) {
            return car.itensPendentesManutencao.map(item => {
                const detalhe = [
                    item.proximaKm ? `Km: ${formatKm(item.proximaKm)}` : null,
                    item.proximaData ? `Data: ${item.proximaData}` : null
                ].filter(Boolean).join(' ');

                return `${item.descricao}${detalhe ? ` - ${detalhe}` : ''}${item.vencida ? ' (vencida)' : ''}`;
            }).join(' | ');
        }
    },

    async mounted() {
        this.loadCarros();

        if (this.dsTime.length === 0 || this.dsCompromissos.length === 0 || this.dsPendencias.length === 0) {
            try {
                const response = await api.get('/dash/Home');
                this.dsTime = response.data.tempos;
                this.totalizadorTempos = response.data.total;
                this.dsPendencias = response.data.pendencias;
                this.dsCompromissos = response.data.compromissos;
                this.updateMinCol();

            } catch (error) {
                console.log(error)

            }
        }
        store.commit(M_MENU, `Home`);
    }

})

